import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { Reward } from '@shared/factory';
import { RewardsConfigType, RewardsDynamicComponent } from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';

@Component({
  selector: 'b2c-reward',
  imports: [NgComponentOutlet],
  templateUrl: './reward.component.html',
})
export class RewardComponent extends BaseComponent {
  reward = input.required<Reward>();

  protected readonly config = <RewardsConfigType>(
    this.loyaltyChallengeConfig.components.rewards
  );

  public components: Signal<
    RewardsDynamicComponent<RewardsConfigType, Reward>
  > = computed(() => {
    return {
      [this.Variants.VARIANT_1]: {
        component: Variant1Component,
        inputs: {
          config: this.config,
          reward: this.reward(),
        },
      },
    };
  });
}
